import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, requireOnboarded = true }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-[60vh] grid place-items-center" data-testid="auth-loading">
        <div className="w-10 h-10 rounded-full border-2 border-[#064E3B] border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  // Onboarding is no longer forced: people arrive from the HikmahVerses dashboard and go straight
  // into the app. /onboarding still exists and `requireOnboarded` is kept so call sites don't change;
  // the backend defaults a missing onboarding record (goal -> "understand").
  return children;
}

export function AdminRoute({ children, allow = ["admin", "support", "mentor"] }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-[60vh] grid place-items-center">
        <div className="w-10 h-10 rounded-full border-2 border-[#064E3B] border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!allow.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}
